const headerClass = 'c-header';
const buttonMenuLargeClass = headerClass + '__button-menu-large';
const buttonMenuLargeActiveClass = buttonMenuLargeClass + '--active';

const headerJsClass = 'js-header';
const buttonMenuSmallJsClass = headerJsClass + '-button-menu-small';
const buttonMenuLargeJsClass = headerJsClass + '-button-menu-large';

const buttonMenuSmallElement = document.querySelector('.' + buttonMenuSmallJsClass) as HTMLElement;
const buttonMenuLargeElements = document.querySelectorAll('.' + buttonMenuLargeJsClass) as NodeListOf<HTMLElement>;

const menuLargeClass = 'c-menu-large';
const menuLargeOpenClass = menuLargeClass + '--open';

const menuLargeJsClass = 'js-menu-large';

const menuLargeElements = document.querySelectorAll('.' + menuLargeJsClass) as NodeListOf<HTMLElement>;

if (buttonMenuSmallElement ) {
    // Add click event listener to small menu button
    buttonMenuSmallElement.addEventListener('click', () => {
        // Dispatch custom event to open small menu
        document.dispatchEvent(new CustomEvent('openMenuSmall'));
    });
}

if (buttonMenuLargeElements) {
    // Add click event listeners to large menu buttons
    buttonMenuLargeElements.forEach((buttonMenuLargeElement, index) => {
        buttonMenuLargeElement.addEventListener('click', () => {
            // Dispatch custom event to toggle large menu
            document.dispatchEvent(new CustomEvent('toggleMenuLarge', {
                detail: { index }
            }));
        });

        buttonMenuLargeElement.addEventListener('keydown', (event) => {
            // If the shift and tab keys are pressed
            if (
                event.key === 'Tab'
                && !event.ctrlKey
                && !event.altKey
                && !event.metaKey
                && event.shiftKey
            ) {
                // If the menu is open
                if (menuLargeElements[index].classList.contains(menuLargeOpenClass)) {
                    // Dispatch custom event to close large menu
                    document.dispatchEvent(new CustomEvent('closeMenuLarge', {
                        detail: { index }
                    }));
                }
            }
        });
    });
}

export function activateButtonMenuLarge (index: number): void {
    if (
        typeof index !== 'number'
        || !buttonMenuLargeElements
        || !buttonMenuLargeElements[index]
        || buttonMenuLargeElements[index].classList.contains(buttonMenuLargeActiveClass)
    ) {
        return;
    }

    // Add the active class to the button
    buttonMenuLargeElements[index].classList.add(buttonMenuLargeActiveClass);

    // Update the aria-expanded property
    buttonMenuLargeElements[index].setAttribute('aria-expanded', 'true');
}

export function deactivateButtonMenuLarge (index: number): void {
    if (
        typeof index !== 'number'
        || !buttonMenuLargeElements
        || !buttonMenuLargeElements[index]
        || !buttonMenuLargeElements[index].classList.contains(buttonMenuLargeActiveClass)
    ) {
        return;
    }

    // Remove the active class from the button
    buttonMenuLargeElements[index].classList.remove(buttonMenuLargeActiveClass);

    // Update the aria-expanded property
    buttonMenuLargeElements[index].setAttribute('aria-expanded', 'false');
}